export const FIND_EDOK_DOCUMENTATIONS_REQUEST = 'FIND_EDOK_DOCUMENTATIONS_REQUEST';

export const findEdokDocumentationsRequest = ({ year }) => ({
    type: FIND_EDOK_DOCUMENTATIONS_REQUEST,
    payload: { year },
});
